module.exports = __webpack_public_path__ + "img/7714b85.jpg";